import MiniQPrev from "./MiniQPrev";
import MiniQ2Prev from "./MiniQ2Prev";

const ManagerSensorsPreview = ({item, t}) => {
    switch (item.model) {
        case "MQ-SX":
            return <MiniQPrev item={item} t={t}/>;
        case "MQ2-4G":
            return <MiniQ2Prev item={item} t={t}/>;
        default:
            break;
    }
}
export default ManagerSensorsPreview;